import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Keeps title, description, canonical, social tags and JSON-LD in sync on client-side navigation.
// The same values are baked into each page's HTML at build time (scripts/prerender.js).
export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    if (path.startsWith('/admin') || path.startsWith('/pay')) return;
    let cancelled = false;
    // Loaded after first paint: every page already ships its meta in the pre-rendered HTML.
    Promise.all([import('./siteMeta'), import('./content.json')]).then(([{ metaFor }, { default: content }]) => {
    if (cancelled) return;
    const meta = metaFor(path, content);
    document.title = meta.title;
    setMeta('name', 'title', meta.title);
    setMeta('name', 'description', meta.description);
    setMeta('name', 'robots', meta.index ? 'index, follow' : 'noindex, follow');
    setCanonical(meta.url);
    for (const [k, v] of [['title', meta.title], ['description', meta.description], ['url', meta.url], ['image', meta.image]]) {
      setMeta('property', `og:${k}`, v);
      setMeta('property', `twitter:${k}`, v);
    }
    let ld = document.getElementById('route-jsonld');
    if (!ld) {
      ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.id = 'route-jsonld';
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(meta.jsonLd);
    });
    return () => { cancelled = true; };
  }, [pathname]);

  return null;
}
